// extracted by mini-css-extract-plugin
export default {"pageHeight":"UserProfile_pageHeight__-Nybv","duploLogoOpaque":"UserProfile_duploLogoOpaque__iZBJP"};